import { useCallback, useState } from 'react';

export type CollapsedGroups = Record<string, boolean>;

export function useCollapsedGroups(initialState: CollapsedGroups = {}) {
  const [collapseGroups, setCollapsedGroups] = useState<CollapsedGroups>(initialState);

  const toggleCollapseGroup = useCallback((key: string, group?: string[]) => {
    setCollapsedGroups((prev) => {
      if (group?.length && key === 'All') {
        const nextAll = !(prev.All ?? false);
        const newState = { ...prev };
        group.forEach((k) => {
          newState[k] = nextAll;
        });
        newState.All = nextAll;
        return newState;
      }
      return { ...prev, All: false, [key]: !prev[key] };
    });
  }, []);

  return { collapseGroups, toggleCollapseGroup };
}
